import * as types from './types'
import storage from '@/Plugins/storage'

export default () => ({
  pager: storage.session.getItem(types.STORE_PAGER)
    ? JSON.parse(storage.session.getItem(types.STORE_PAGER))
    : {
        pageSize: 10,
        orderBy: 'desc',
        sortBy: 'id',
        search: null,
        total: 0,
        page: 1,
        pages: 1,
      },
  defaultMeasurement: {
    id: null,
    organization_id: null,
    subject: '',
    body: '',
    type: '',
    isInactive: false,
    isInvite: false,
  },
  measurement: null,
  measurements: [],
  photos: [],
  vo2assessment: null,
  vo2assessments: [],
})
